import { RouteObject } from "react-router-dom";
import Preview from "../pages/Content/Preview";
import Person from "../pages/Catalogs/Person";
import Language from "../pages/Catalogs/Language";
import AddLanguage from "../pages/Catalogs/CRUD/AddLanguage";
import BarAdmission from "../pages/Catalogs/BarAdmission";
import AddBarAdmission from "../pages/Catalogs/CRUD/AddBarAdmission";
import Country from "../pages/Catalogs/Country";
import AddCountry from "../pages/Catalogs/CRUD/AddCountry";
import Region from "../pages/Catalogs/Region";
import AddRegion from "../pages/Catalogs/CRUD/AddRegion";
import City from "../pages/Catalogs/City";
import AddCity from "../pages/Catalogs/CRUD/AddCity";
import Degree from "../pages/Catalogs/Degree";
import AddDegree from "../pages/Catalogs/CRUD/AddDegree";
import School from "../pages/Catalogs/School";
import AddSchool from "../pages/Catalogs/CRUD/AddSchool";
import State from "../pages/Catalogs/State";
import AddState from "../pages/Catalogs/CRUD/AddState";
import SubState from "../pages/Catalogs/SubState";
import AddSubState from "../pages/Catalogs/CRUD/AddSubState";
import Firm from "../pages/Catalogs/Firm";
import AddFirm from "../pages/Catalogs/CRUD/AddFirm";
import Address from "../pages/Catalogs/Address";
import AddAddress from "../pages/Catalogs/CRUD/AddAddress";
import Office from "../pages/Catalogs/Office";
import AddOffice from "../pages/Catalogs/CRUD/AddOffice";
import PracticeIndustry from "../pages/Catalogs/PracticeIndustry";
import AddPracticeIndustry from "../pages/Catalogs/CRUD/AddPracticeIndustry";
import AddDataAdmin from "../pages/Catalogs/CRUD/AddDataAdmin";
import FirmContact from "../pages/Catalogs/FirmContact";
import FirmContactView from "../pages/Catalogs/FirmContactView";
import AddFirmContact from "../pages/Catalogs/CRUD/AddFirmContact";
import WSG from "../pages/Catalogs/WSG";
import AddWSG from "../pages/Catalogs/CRUD/addWSG";
import User from "../pages/Catalogs/User";
import AddUser from "../pages/Catalogs/CRUD/AddUser";
import DataAdmin from "../pages/Catalogs/DataAdmin";
import OfficeContact from "../pages/Catalogs/OfficeContacts";
import OfficeContactView from "../pages/Catalogs/OfficeContactsView";
import OfficeContactsEdit from "../pages/Catalogs/OfficeContactsEdit";
import FirmNote from "../pages/Catalogs/FirmNote";
import AddFirmNote from "../pages/Catalogs/CRUD/AddFirmNote";
import AreaOfPractice from "../pages/Catalogs/AreaOfPractice";
import AddAOP from "../pages/Catalogs/CRUD/AddAOP";
import RepresentativeClient from "../pages/Catalogs/RepresentativeClient";
import AddRepresentativeClient from "../pages/Catalogs/CRUD/AddRepresentativeClient";
import AOPRanking from "../pages/Catalogs/AOPRanking";
import AddAOPRanking from "../pages/Catalogs/CRUD/AddAopRanking";
import Education from "../pages/Catalogs/Education";
import AddEducation from "../pages/Catalogs/CRUD/AddEducation";
import ContentGeneralTopic from "../pages/Catalogs/ContentGeneralTopic";
import AddContentGeneralTopic from "../pages/Catalogs/CRUD/AddContentGeneralTopic";
import GlobalCrisis from "../pages/Catalogs/GlobalCrisis";
import AddGlobalCrisis from "../pages/Catalogs/CRUD/AddGlobalCrisis";
import ContentTag from "../pages/Catalogs/ContentTag";
import AddContentTag from "../pages/Catalogs/CRUD/AddContentTag";
import Content from "../pages/Catalogs/Content";
import AddContent from "../pages/Catalogs/CRUD/AddContent";
import AddGroupPhotos from "../pages/Catalogs/CRUD/AddGroupPhotos";
import AddEventPhotoGallery from "../pages/Catalogs/CRUD/AddEventPhotoGallery";
import LegacyRegistrationInserter from "../components/TestingCatalogs/RegistrationCRUD/LegacyRegistrationInserter";
import LegacyEventInserter from "../components/TestingCatalogs/EventCRUD/LegacyEventInserter";
import AddProfessional from "../components/Organismos/Person/AddProfessional";
import PersonDataAudit from "../pages/Catalogs/PersonDataAudit";

export const SuperAdminRoutes: RouteObject[] = [
  {
    path: "/catalogs/person/create",
    element: <AddProfessional mode="add" catalogMode />,
  },
  {
    path: "/catalogs/person/edit/:id",
    element: <AddProfessional mode="edit" catalogMode />,
  },
  {
    path: "/catalogs/person",
    element: <Person />,
  },
  {
    path: "/catalogs/person-audit",
    element: <PersonDataAudit />,
  },
  {
    path: "/catalogs/language",
    element: <Language />,
  },
  {
    path: "/catalogs/language/create",
    element: <AddLanguage mode="add" />,
  },
  {
    path: "/catalogs/language/edit/:id",
    element: <AddLanguage mode="edit" />,
  },
  {
    path: "/catalogs/baradmission",
    element: <BarAdmission />,
  },
  {
    path: "/catalogs/baradmission/create",
    element: <AddBarAdmission mode="add" />,
  },
  {
    path: "/catalogs/baradmission/edit/:id",
    element: <AddBarAdmission mode="edit" />,
  },
  {
    path: "/catalogs/country",
    element: <Country />,
  },
  {
    path: "/catalogs/country/create",
    element: <AddCountry mode="add" />,
  },
  {
    path: "/catalogs/country/edit/:id",
    element: <AddCountry mode="edit" />,
  },
  {
    path: "/catalogs/region",
    element: <Region />,
  },
  {
    path: "/catalogs/region/create",
    element: <AddRegion mode="add" />,
  },
  {
    path: "/catalogs/region/edit/:id",
    element: <AddRegion mode="edit" />,
  },
  {
    path: "/catalogs/city",
    element: <City />,
  },
  {
    path: "/catalogs/city/create",
    element: <AddCity mode="add" />,
  },
  {
    path: "/catalogs/city/edit/:id",
    element: <AddCity mode="edit" />,
  },
  {
    path: "/catalogs/degree",
    element: <Degree />,
  },
  {
    path: "/catalogs/degree/create",
    element: <AddDegree mode="add" />,
  },
  {
    path: "/catalogs/degree/edit/:id",
    element: <AddDegree mode="edit" />,
  },
  {
    path: "/catalogs/school",
    element: <School />,
  },
  {
    path: "/catalogs/school/create",
    element: <AddSchool mode="add" />,
  },
  {
    path: "/catalogs/school/edit/:id",
    element: <AddSchool mode="edit" />,
  },
  {
    path: "/catalogs/state",
    element: <State />,
  },
  {
    path: "/catalogs/state/create",
    element: <AddState mode="add" />,
  },
  {
    path: "/catalogs/state/edit/:id",
    element: <AddState mode="edit" />,
  },
  {
    path: "/catalogs/substate",
    element: <SubState />,
  },
  {
    path: "/catalogs/substate/create",
    element: <AddSubState mode="add" />,
  },
  {
    path: "/catalogs/substate/edit/:id",
    element: <AddSubState mode="edit" />,
  },
  {
    path: "/catalogs/firm",
    element: <Firm />,
  },
  {
    path: "/catalogs/firm/create",
    element: <AddFirm mode="add" />,
  },
  {
    path: "/catalogs/firm/edit/:id",
    element: <AddFirm mode="edit" />,
  },
  {
    path: "/catalogs/address",
    element: <Address />,
  },
  {
    path: "/catalogs/address/create",
    element: <AddAddress mode="add" />,
  },
  {
    path: "/catalogs/address/edit/:id",
    element: <AddAddress mode="edit" />,
  },
  {
    path: "/catalogs/office",
    element: <Office />,
  },
  {
    path: "/catalogs/office/create",
    element: <AddOffice mode="add" />,
  },
  {
    path: "/catalogs/office/edit/:id",
    element: <AddOffice mode="edit" />,
  },
  {
    path: "/catalogs/practiceindustry",
    element: <PracticeIndustry />,
  },
  {
    path: "/catalogs/practiceindustry/create",
    element: <AddPracticeIndustry mode="add" />,
  },
  {
    path: "/catalogs/practiceindustry/edit/:id",
    element: <AddPracticeIndustry mode="edit" />,
  },
  {
    path: "/catalogs/firmcontact",
    element: <FirmContact />,
  },
  {
    path: "/catalogs/firmcontact/view/:id",
    element: <FirmContactView />,
  },
  {
    path: "/catalogs/firmcontact/edit/:id",
    element: <AddFirmContact />,
  },
  {
    path: "/catalogs/wsg",
    element: <WSG />,
  },
  {
    path: "/catalogs/wsg/create",
    element: <AddWSG mode="add" />,
  },
  {
    path: "/catalogs/wsg/edit/:id",
    element: <AddWSG mode="edit" />,
  },
  {
    path: "/catalogs/user",
    element: <User />,
  },
  {
    path: "/catalogs/user/create",
    element: <AddUser mode="add" />,
  },
  {
    path: "/catalogs/user/edit/:id",
    element: <AddUser mode="edit" />,
  },
  {
    path: "/catalogs/dataadmin",
    element: <DataAdmin />,
  },
  {
    path: "/catalogs/dataadmin/create",
    element: <AddDataAdmin mode="add" />,
  },
  {
    path: "/catalogs/dataadmin/edit/:id",
    element: <AddDataAdmin mode="edit" />,
  },
  {
    path: "/catalogs/membermaincontact",
    element: <OfficeContact />,
  },
  {
    path: "/catalogs/membermaincontact/view/:id",
    element: <OfficeContactView />,
  },
  {
    path: "/catalogs/membermaincontact/edit/:id",
    element: <OfficeContactsEdit />,
  },
  {
    path: "/catalogs/firmnote",
    element: <FirmNote />,
  },
  {
    path: "/catalogs/firmnote/create",
    element: <AddFirmNote mode="add" />,
  },
  {
    path: "/catalogs/firmnote/edit/:id",
    element: <AddFirmNote mode="edit" />,
  },
  {
    path: "/catalogs/areaofpractice",
    element: <AreaOfPractice />,
  },
  {
    path: "/catalogs/areaofpractice/create",
    element: <AddAOP returnPage="/catalogs/areaofpractice" mode="add" />,
  },
  {
    path: "/catalogs/areaofpractice/edit/:id",
    element: <AddAOP returnPage="/catalogs/areaofpractice" mode="edit" />,
  },
  {
    path: "/catalogs/representativeclient",
    element: <RepresentativeClient />,
  },
  {
    path: "/catalogs/representativeclient/create",
    element: <AddRepresentativeClient mode="add" />,
  },
  {
    path: "/catalogs/representativeclient/edit/:id",
    element: <AddRepresentativeClient mode="edit" />,
  },
  {
    path: "/catalogs/aopranking",
    element: <AOPRanking />,
  },
  {
    path: "/catalogs/aopranking/create",
    element: <AddAOPRanking mode="add" />,
  },
  {
    path: "/catalogs/aopranking/edit/:id",
    element: <AddAOPRanking mode="edit" />,
  },
  {
    path: "/catalogs/education",
    element: <Education />,
  },
  {
    path: "/catalogs/education/create",
    element: <AddEducation mode="add" />,
  },
  {
    path: "/catalogs/education/edit/:id",
    element: <AddEducation mode="edit" />,
  },
  {
    path: "/catalogs/contentgeneraltopic",
    element: <ContentGeneralTopic />,
  },
  {
    path: "/catalogs/contentgeneraltopic/create",
    element: <AddContentGeneralTopic mode="add" />,
  },
  {
    path: "/catalogs/contentgeneraltopic/edit/:id",
    element: <AddContentGeneralTopic mode="edit" />,
  },
  {
    path: "/catalogs/globalcrisis",
    element: <GlobalCrisis />,
  },
  {
    path: "/catalogs/globalcrisis/create",
    element: <AddGlobalCrisis mode="add" />,
  },
  {
    path: "/catalogs/globalcrisis/edit/:id",
    element: <AddGlobalCrisis mode="edit" />,
  },
  {
    path: "/catalogs/publicationtag",
    element: <ContentTag />,
  },
  {
    path: "/catalogs/publicationtag/create",
    element: <AddContentTag mode="add" />,
  },
  {
    path: "/catalogs/publicationtag/edit/:id",
    element: <AddContentTag mode="edit" />,
  },
  {
    path: "/catalogs/content",
    element: <Content />,
  },
  {
    path: "/catalogs/content/create",
    element: <AddContent mode="add" redirectURL="/catalogs/content" />,
  },
  {
    path: "/catalogs/content/edit/:id",
    element: <AddContent mode="edit" redirectURL="/catalogs/content" />,
  },
  {
    path: "/AddGroupPhotos",
    element: <AddGroupPhotos />,
  },
  {
    path: "/AddEventPhotoGallery",
    element: <AddEventPhotoGallery />,
  },
  {
    path: "/registration",
    element: <LegacyRegistrationInserter />,
  },
  {
    path: "/legacy-events",
    element: <LegacyEventInserter />,
  },
  {
    path: "/catalogs/content/preview",
    element: (
      <Preview
        canComment={false}
        showComments={false}
        canEdit={false}
        breadcrumb={{
          prevPage: "Edit Content",
          currentPage: "Preview",
        }}
      />
    ),
  },
];
